<template>
  <div class="mobile-captcha-wrapper">
    <cube-form-item
      :field="fieldConfig"
      class="imgcode mobile-captcha"
      v-bind="$attrs"
    >
      <div class="captcha-content">
        <cube-input
          v-model="localValue"
          :placeholder="placeholder"
          :maxlength="maxlength"
          class="mobile-captcha-input"
        />
        <cube-button
          class="mobile-captcha-btn"
          @click="refreshCaptcha"
        >
          <img
            :src="captchaUrl"
            alt="验证码"
            title="点击刷新"
            class="mobile-captcha-img"
          >
        </cube-button>
      </div>
    </cube-form-item>
  </div>
</template>

<script>

import { apiDomain } from '@/lib/config'
const CAPTCHA_URL = `${apiDomain}/user/common/image`

export default {
  name: 'MobileCaptchaInput',
  inheritAttrs: false,
  props: {
    // 标签文本
    label: {
      type: String,
      default: ''
    },
    // 输入值，用于v-model
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '图片验证码'
    },
    maxlength: {
      type: [String, Number],
      default: 5
    }
  },
  computed: {
    fieldConfig () {
      return {
        label: this.label
      }
    }
  },
  data () {
    return {
      captchaUrl: `${CAPTCHA_URL}?t=${Date.now()}`,
      localValue: this.value
    }
  },
  watch: {
    value (newVal) {
      this.localValue = newVal
    },
    localValue (newVal) {
      this.$emit('input', newVal)
    }
  },
  mounted () {
    // this.refreshCaptcha()
  },
  methods: {
    refreshCaptcha () {
      // this.captcha = ''
      this.captchaUrl = `${CAPTCHA_URL}?t=${Date.now()}`
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-captcha-wrapper {
  width: 100%;
}

.mobile-captcha {
  margin-bottom: 16px;

  ::v-deep .cube-form-item-label {
    text-align: left;
    padding-bottom: 8px;
    label {
      font-size: 14px;
      color: #333;
      font-weight: normal;
    }
  }

  ::v-deep .cube-form-item-control {
    line-height: 1.5;
  }
}

.captcha-content {
  display: flex;
  align-items: center;
  width: 100%;
}

.mobile-captcha-input {
  flex: 1;
  height: 40px;
  border-radius: 4px;
  // border: 1px solid #e5e5e5; /* 使用更标准的边框颜色 */
  font-size: 14px;
  padding: 0;

  &::placeholder {
    color: #c0c4cc;
    font-size: 14px;
  }

  &:focus {
    border-color: #409eff;
    outline: none;
  }
}

.mobile-captcha-btn {
  margin-left: 10px;
  padding: 0;
  border: none;
  background: none;
  height: 40px;
  width: 36%; /* 改为不超过总宽度的50% */
  max-width: 120px; /* 保持最大宽度限制 */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  overflow: hidden;

  &:active {
    opacity: 0.8;
    background-color: #f5f5f5;
  }
}

.mobile-captcha-img {
  height: 36px;
  width: auto;
  border-radius: 2px;
}
</style>